<template>
  <v-container
    v-if="!uiStore.showLoader && !uiStore.errorMsg"
    class="text-grey-darken-1 mt-4 py-0"
    max-width="1200"
  >
    <AdminInvoiceTracking />
  </v-container>
</template>

<script setup lang="ts">
import { useUiStore } from "@/stores/uiStore";

definePage({
  meta: {
    adminOnly: true,
  },
});

const uiStore = useUiStore();
</script>
